export default "https://static.homerun.co/images/chart-line.svg?bd16d8a8e5a65daa02eb5a01c74e5d64";